import { render, staticRenderFns } from "./project-charter-list.vue?vue&type=template&id=77bdcaae"
import script from "./project-charter-list.vue?vue&type=script&lang=js"
export * from "./project-charter-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports